import {actions} from "../constants/app_constants.js";
import { authenticationService } from "../services/authenticationService.js";
import i18n from '../utils/localizations.jsx';
import { utils } from "../utils/utils";
import { post, get } from 'axios';

export const request_helper =
{
    callWithDispatch,
    callWithDispatchBase,
    callWithDispatchReport,
    uploadFileWithDispatch,
    downloadFileWithDispatch
}

async function callWithDispatch(dispatch, method, apiUrl, content) {
    dispatch({ type: actions.START_REQUEST });
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('l', i18n.language);
    headers.append('Authorization', 'Bearer ' + authenticationService.currentUserValue.token);
    const requestOptions = {
        method: method,
        headers,
        body: content ? JSON.stringify(content) : null
    };
    const request = new Request(apiUrl, requestOptions);
    let response = await fetch(request);
    
    if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (await response.json()) || response.statusCode;
        dispatch({ type: actions.HANDLE_ERROR, error});
        throw new Error(error);
    }

    const data = await response.json();
    return data;
}

async function callWithDispatchBase(dispatch, method, apiUrl, content) {
    dispatch({ type: actions.START_REQUEST });
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('l', i18n.language);
    headers.append('Authorization', 'Bearer ' + authenticationService.currentUserValue.token);
    const requestOptions = {
        method: method,
        headers,
        body: content ? JSON.stringify(content) : null
    };
    const request = new Request(apiUrl, requestOptions);
    let response = await fetch(request);

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (await response.json()) || response.statusCode;
        dispatch({ type: actions.HANDLE_ERROR, error });
        throw new Error(error);
    }

    return response;
}

async function uploadFileWithDispatch(dispatch, apiUrl, file) {
    dispatch({ type: actions.START_REQUEST });
    let formData = new FormData();
    formData.append("file", file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            'l': i18n.language
        },
    };

    let response = await post(apiUrl, formData, config);
    console.log(response);
    if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
            authenticationService.logout();
            
        }
        let error = response.data;
        dispatch({ type: actions.HANDLE_ERROR, error });
        throw new Error(error);
    }
    dispatch({ type: actions.END_REQUEST });
    return response.data;
}

async function downloadFileWithDispatch(dispatch, apiUrl) {
    dispatch({ type: actions.START_REQUEST });
    const config = {
        headers: {
            'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            'l': i18n.language
        },
        responseType: 'blob'
    };

    const response = await get(apiUrl, config);
    console.log(response);
    if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
            authenticationService.logout();

        }
        let error = response.data;
        dispatch({ type: actions.HANDLE_ERROR, error });
        throw new Error(error);
    }
    dispatch({ type: actions.END_REQUEST });
    let fileResponse = {
        file: new Blob([response.data]),
        fileName: response.headers['content-disposition'].split('filename=')[1].split(';')[0].trim()
    }
    return fileResponse;
}

async function callWithDispatchReport(dispatch, method, apiUrl, content) {
    dispatch({ type: actions.START_REQUEST });
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('l', i18n.language);
    headers.append('Authorization', 'Bearer ' + authenticationService.currentUserValue.token);
    const requestOptions = {
        method: method,
        headers,
        body: content ? JSON.stringify(content) : null
    };
    const request = new Request(apiUrl, requestOptions);
    let response = await fetch(request);

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (await response.json()) || response.statusCode;
        dispatch({ type: actions.HANDLE_ERROR, error });
        throw new Error(error);
    }

    const data = await response.text();
    const blob = new Blob([utils.base64toBlob(data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});
    dispatch({ type: actions.END_REQUEST });
    return blob;
}